// core
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from "rxjs";
import { startWith } from 'rxjs/operators';
import { distinctUntilChanged } from "rxjs/operators";

// Raptor
import { RaptorControlService } from '../../services/raptor-control.service';
import { RaptorPredicateService } from '../../services/raptor-predicate.service';
import { RaptorStepService } from '../../services/raptor-step.service';
import { RaptorStepDataService } from '../../services/raptor-step-data.service';
import { RaptorAnalyticsService } from '../../services/raptor-analytics.service';
import { RaptorCurrencyPipe } from '../../pipes/raptor-currency.pipe';

@Component({
  selector: 'open-raptor-question-review',
  templateUrl: './raptor-question-review.component.html',
  styleUrls: ['./raptor-question-review.component.scss']
})
export class RaptorQuestionReviewComponent implements OnInit {
  @Input() element: any;
  @Input() form!: FormGroup;
  @Input() context!: string;

  showQuestionReview = true;
  formValueWatcher!: Subscription;
  extras!: Array<any>;

  constructor(
    private raptorPredicateService: RaptorPredicateService,
    private raptorControlService: RaptorControlService,
    private raptorStepService: RaptorStepService,
    private raptorAnalyticsService: RaptorAnalyticsService,
    private raptorStepDataService: RaptorStepDataService,
    private raptorCurrencyPipe: RaptorCurrencyPipe
  ) { }

  ngOnInit(): void {
    if (this.element.show_if && typeof this.element.show_if === 'object') {
      this.checkShowIf();

      this.formValueWatcher = this.form.valueChanges
        .pipe(
          startWith(this.form.value),
          distinctUntilChanged((previous, current) => {
            return !this.raptorControlService.formValueChanged(previous, current);
          })
        )
        .subscribe(data => {
          this.checkShowIf();
        });
    }
    
    if (this.element.type === 'extras') {
      let formData = this.raptorStepDataService.get();
      let selectedCover = formData.covers.find((item: any) => {
        return item.cover.product_slug === formData.data.product_slug &&
          item.cover.cover_type === formData.data.cover_type &&
          item.cover.cover_level === formData.data.cover_level;
      });
      this.extras = [];
      if (
        selectedCover &&
        selectedCover.extras &&
        this.element.settings &&
        this.element.settings.choices &&
        this.element.settings.choices.length
      ) {
        for (let key in selectedCover.extras) {
          if (selectedCover.extras[key].is_included) {
            let selectedExtra = this.element.settings.choices.find((choice: any) => {
              return choice.value === key;
            });
            if (selectedExtra) {
              this.extras.push(selectedExtra);
            }
          }
        }
      }
    }

    if (Array.isArray(this.element.human)) {
      this.element.human = this.element.human.join(', ');
    }
  }

  ngOnDestroy(): void {
    if (this.formValueWatcher) {
      this.formValueWatcher.unsubscribe();
    }
  }

  getRepeaterElementDetails(childElement: any, repeater: any, dataIndex: number) {
    const data = repeater.data && repeater.data[dataIndex] && repeater.data[dataIndex][childElement.key];
    const human = repeater.human && repeater.human[dataIndex] && repeater.human[dataIndex][childElement.key];

    return {...childElement, data, human };
  }

  checkShowIf(): void {
    this.showQuestionReview = this.raptorPredicateService.validator(this.element.show_if, this.form.value);
  }

  onEditQuestionClick(key: string): void {
    // if question is repeater child take repeater key only
    const questionKey = key.split('__')[0];
    this.raptorAnalyticsService.trackAdditionalEvents('select-option', 'edit', questionKey);
    this.raptorStepService.setQuestionToEdit(questionKey);
  }

  applyCurrency(element: any) {
    return this.raptorCurrencyPipe.transform(element, element.data);
  }
}
